import { differenceInDays as differenceInDaysFns } from 'date-fns/differenceInDays';

type IDifferenceInDays = (args: { laterDate: Date; earlierDate: Date }) => number;

/**
 * 2 つの日付の差を、フルの日数（1 日に満たない端数は切り捨て）で返す
 *
 * date-fns の differenceInDays をそのまま利用する薄いラッパー。
 * laterDate が earlierDate より後なら正、前なら負の値を返す。ブラウザのローカル時間で判定する。
 */
export const differenceInDays: IDifferenceInDays = ({ laterDate, earlierDate }) =>
  differenceInDaysFns(laterDate, earlierDate);
